import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const pageInfo = {
    '/neden-emur': { title: 'Neden EMUR?', desc: 'Bizi tercih etmeniz için nedenler', icon: '⭐' },
    '/bilgi-guvenligi': { title: 'Bilgi Güvenliği Politikamız', desc: 'ISO 27001 sertifikalı güvenlik politikamız', icon: '🔒' },
    '/is-ortaklarimiz': { title: 'İş Ortaklarımız', desc: 'Global teknoloji iş ortaklıklarımız', icon: '🤝' },
    '/referanslarimiz': { title: 'Referanslarımız', desc: 'Güvenen kurum ve kuruluşlar', icon: '📊' },
    '/basari-hikayeleri': { title: 'Başarı Hikayeleri', desc: 'Müşterilerimizin başarı öyküleri', icon: '🏆' },
    '/insan-kaynaklari': { title: 'İnsan Kaynakları', desc: 'Kariyerinizi bizimle geliştirin', icon: '👥' },
    '/basinda-biz': { title: 'Basında Biz', desc: 'Medyada EMUR INNOVATION', icon: '📰' },
    '/destek': { title: 'Destek Merkezi', desc: '7/24 teknik destek hizmetimiz', icon: '🎫' },
    '/giris': { title: 'Giriş', desc: 'Hesabınıza giriş yapın', icon: '🔑' },
    '/kayit': { title: 'Kayıt', desc: 'Yeni hesap oluşturun', icon: '📝' },
    '/gizlilik': { title: 'Gizlilik Sözleşmesi', desc: 'Kişisel verilerin korunması hakkında bilgilendirme', icon: '📄' },
    '/hizmet-sozlesmesi': { title: 'Hizmet Sözleşmesi', desc: 'Hizmet şartları ve koşulları', icon: '📋' },
    '/kvk-aydinlatma': { title: 'KVK Aydınlatma Metni', desc: 'KVKK kapsamında aydınlatma metni', icon: '📜' },
};

function PlaceholderPage() {
    const location = useLocation();
    const info = pageInfo[location.pathname] || {
        title: 'Sayfa Bulunamadı',
        desc: 'Aradığınız sayfa mevcut değil.',
        icon: '🔍'
    };
    const is404 = !pageInfo[location.pathname];

    return (
        <>
            <section className="page-hero">
                <div className="container">
                    <h1>{info.title}</h1>
                    <p>{info.desc}</p>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <div style={{
                        maxWidth: '640px',
                        margin: '0 auto',
                        textAlign: 'center',
                        padding: '60px 0'
                    }}>
                        <div style={{
                            width: '100px',
                            height: '100px',
                            borderRadius: '24px',
                            background: 'linear-gradient(135deg, rgba(13, 43, 92, 0.08), rgba(37, 99, 235, 0.04))',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '2.5rem',
                            margin: '0 auto 32px'
                        }}>
                            {info.icon}
                        </div>

                        {is404 ? (
                            <>
                                <h2 style={{
                                    fontSize: '1.75rem',
                                    fontWeight: 800,
                                    marginBottom: '16px',
                                    color: 'var(--foreground)'
                                }}>
                                    404 — Sayfa Bulunamadı
                                </h2>
                                <p style={{
                                    color: 'var(--muted-foreground)',
                                    lineHeight: 1.8,
                                    marginBottom: '32px'
                                }}>
                                    Aradığınız sayfa taşınmış veya silinmiş olabilir.
                                </p>
                            </>
                        ) : (
                            <>
                                <h2 style={{
                                    fontSize: '1.75rem',
                                    fontWeight: 800,
                                    marginBottom: '16px',
                                    color: 'var(--foreground)'
                                }}>
                                    Yakında Sizlerle
                                </h2>
                                <p style={{
                                    color: 'var(--muted-foreground)',
                                    lineHeight: 1.8,
                                    marginBottom: '12px'
                                }}>
                                    Bu sayfa şu anda hazırlanıyor. Çok yakında burada olacak.
                                </p>
                                <p style={{
                                    color: 'var(--muted-foreground)',
                                    lineHeight: 1.8,
                                    marginBottom: '32px',
                                    fontSize: '0.9rem'
                                }}>
                                    Güncellemelerden haberdar olmak için bültenimize abone olabilirsiniz.
                                </p>
                            </>
                        )}

                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                            <Link to="/" className="btn btn-primary">Ana Sayfaya Dön</Link>
                            <Link to="/iletisim" className="btn btn-outline">İletişim</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default PlaceholderPage;
